import { SYNC_FIELDS } from "constants";
import { Autocomplete, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { useSearchParams } from "react-router-dom";

export default function SearchParamControlledAutocomplete({
  searchParam,
  label,
  options,
  getOptionLabel = (option) => option,
  isOptionEqualToValue = (option, value) => option === value,
  ...rest
}) {
  SearchParamControlledAutocomplete.propTypes = {
    searchParam: PropTypes.oneOf(Object.values(SYNC_FIELDS)).isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    getOptionLabel: PropTypes.func,
    isOptionEqualToValue: PropTypes.func,
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const currentValue =
    options.find((opt) =>
      typeof opt === "object"
        ? opt.slug === searchParams.get(searchParam)
        : opt === searchParams.get(searchParam)
    ) || null;

  const onChangeFilter = (key, newValue) => {
    const { [key]: current, ...otherParams } = Object.fromEntries(searchParams);
    if (newValue) {
      const paramVal = typeof newValue === "object" ? newValue.slug : newValue;
      setSearchParams({ ...otherParams, [key]: paramVal });
    } else {
      setSearchParams(otherParams);
    }
  };

  return (
    <Autocomplete
      id={`${searchParam}-autocomplete`}
      value={currentValue}
      options={options}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      onChange={(_, val) => onChangeFilter(searchParam, val)}
      renderInput={(params) => (
        <TextField {...params} label={label} size="small" sx={{ minWidth: 200 }} />
      )}
      {...rest}
    />
  );
}
